/** @import Status from '@/classes/scoped-list/Status' */

/**
 * Clase para representar un fichero subido
 */
export default class FileItem {
  /** @type {String?} */ name = null
  /** @type {Number?} */ percentage = null
  /** @type {File?} */ raw = null
  /** @type {Number?} */ size = null
  /** @type {String?} */ status = null
  /** @type {Number?} */ uid = null
  /** @type {Boolean?} */ loading = null
  /** @type {String?} */ tooltip = null
  /** @type {Status?} */ estado = null
  /** @type {Array<FileItem>?} */ files = null
}
